import { ModalManager, ModalProps } from './modal-manager'
import { LoginModal } from 'components/modals/LoginModal'
import { OpenTicketModal } from 'components/modals/OpenTicketModal'
import { OpenChatModal } from 'components/modals/OpenChatModal'
import { CloseTicketModal } from 'components/modals/CloseTicketModal'
import { ExportChatModal } from 'components/modals/ExportChatModal'

export const showModal = ({ children }: ModalProps) => {
  ModalManager.show({
    children,
  })
}

export const showOpenTicketModal = () => {
  showModal({
    children: <OpenTicketModal />,
  })
}

export const showCloseTicketModal = (ticketId: string) => {
  showModal({
    children: <CloseTicketModal ticketId={ticketId} />,
  })
}

export const showExportChatModal = () => {
  showModal({
    children: <ExportChatModal />,
  })
}

export const showOpenChatModal = () => {
  showModal({
    children: <OpenChatModal />,
  })
}

export const showLoginModal = () => {
  showModal({
    children: <LoginModal />,
  })
}

export const hideModal = () => {
  ModalManager.hide()
}
